type Level = "info" | "warn" | "error";

function log(level: Level, ctx: string, msg: string, data?: unknown): void {
  const prefix = `[${ctx}]`;
  if (level === "error") {
    console.error(prefix, msg, ...(data !== undefined ? [data] : []));
    // TODO FASE 6: forward to Supabase error_logs or Sentry in production
  } else if (!import.meta.env.PROD) {
    const fn = level === "warn" ? console.warn : console.info;
    fn(prefix, msg, ...(data !== undefined ? [data] : []));
  }
}

export const logger = {
  info:  (ctx: string, msg: string, data?: unknown) => log("info",  ctx, msg, data),
  warn:  (ctx: string, msg: string, data?: unknown) => log("warn",  ctx, msg, data),
  error: (ctx: string, msg: string, data?: unknown) => log("error", ctx, msg, data),
};
